var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"t-icon",class:[_vm.colorVariant]},[_c('svg',{staticClass:"t-icon__svg",attrs:{"width":_vm.width || _vm.size,"height":_vm.height || _vm.size,"viewBox":_vm.viewBox,"role":"img","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":_vm.icon}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }